import { type ThemePreset, ThemeProvider } from '@wl/ui';
import { createContext, type ReactNode, useContext, useState } from 'react';

const KEY = 'wl-admin-theme';
const PRESETS: ThemePreset[] = ['light', 'dark', 'oled'];

const Ctx = createContext<{ preset: ThemePreset; setPreset: (p: ThemePreset) => void }>({ preset: 'light', setPreset: () => undefined });

function initial(): ThemePreset {
  const saved = localStorage.getItem(KEY) as ThemePreset | null;
  if (saved && PRESETS.includes(saved)) return saved;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/** Platform paneli kendi markasını kullanır; tema tercihi tarayıcıda saklanır. */
export function AdminThemeProvider({ children }: { children: ReactNode }) {
  const [preset, setPresetState] = useState<ThemePreset>(initial);
  const setPreset = (p: ThemePreset) => {
    localStorage.setItem(KEY, p);
    setPresetState(p);
  };
  return (
    <Ctx.Provider value={{ preset, setPreset }}>
      <ThemeProvider brand={{ presets: PRESETS, defaultPreset: 'light', primaryColor: '#4f46e5' }} preset={preset}>
        {children}
      </ThemeProvider>
    </Ctx.Provider>
  );
}

export function useAdminTheme() {
  return useContext(Ctx);
}
